export default "__VITE_ASSET__19e46409__"